import { combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { StateType } from 'typesafe-actions';
import { History } from 'history';
import { connectRouter, RouterState } from 'connected-react-router';
import sharedComponents from './components';
import { default as app } from './app';
import { AppConfig } from 'types/config';

const makeRootReducers = (history: History, componentsReducer: Reducer) =>
  combineReducers({
    router: connectRouter(history),
    app,
    form: formReducer,
    sharedComponents,
    components: componentsReducer,
    config: (state: AppConfig | {} = {}): AppConfig | {} => state,
  });

export default makeRootReducers;

export type RootState = StateType<ReturnType<typeof makeRootReducers>> & { router: RouterState };
